export const FETCH_OFFERS_AND_EVENTS = 'fetchOffersAndEvents';
